export const AUTH_ANALYTICS_EVENTS = {
  LOGIN: "user-login",
  FORGOT_PASSWORD: "user-forgot-password",
  RESET_PASSWORD: "user-reset-password",
  SIGNUP: "user-signup",
};
